import {
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faFileImage,
  faFile,
  faFileZipper,
  faFilePdf,
  faFileAudio,
  faFileVideo,
  faFileLines,
} from '@fortawesome/pro-duotone-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export const getIconByDocType = (type: string): IconDefinition => {
  switch (type) {
    case 'application/pdf':
      return faFilePdf;
    case 'application/msword':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    case 'application/vnd.ms-word.document.macroEnabled.12':
    case 'application/vnd.ms-word.template.macroEnabled.12':
      return faFileWord;
    case 'application/vnd.ms-excel':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return faFileExcel;
    case 'application/vnd.ms-powerpoint':
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      return faFilePowerpoint;
    case 'image/jpeg':
    case 'image/png':
    case 'image/gif':
    case 'image/bmp':
    case 'image/svg+xml':
    case 'image/eps':
      return faFileImage;
    case 'application/vnd.rar':
    case 'application/x-tar':
    case 'application/zip':
    case 'application/x-bzip':
    case 'application/x-bzip2':
    case 'application/x-rar-compressed':
    case 'application/x-7z-compressed':
      return faFileZipper;
    case 'text/csv':
    case 'application/xml':
    case 'text/xml':
    case 'text/plain':
      return faFileLines;
    case 'audio/mpeg':
    case 'audio/mp3':
      return faFileAudio;
    case 'video/mp4':
    case 'video/quicktime':
      return faFileVideo;
    default:
      return faFile;
  }
};

export const formatFileSize = (bytes: number): string => {
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 B';
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
};

export const getFileContentTitle = (type: string, quantity: number) => {
  switch (type) {
    case 'application/pdf':
    case 'application/msword':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    case 'application/vnd.ms-word.document.macroEnabled.12':
    case 'application/vnd.ms-word.template.macroEnabled.12':
      return getPluralizedTitle('Seite', quantity);
    case 'application/vnd.ms-excel':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return getPluralizedTitle('Tabelle', quantity);
    case 'application/vnd.ms-powerpoint':
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      return getPluralizedTitle('Folie', quantity);
    default:
      return quantity > 1 ? 'Teile' : 'Teil';
  }
};

const getPluralizedTitle = (title: string, quantity: number) => {
  if (quantity <= 1) {
    return title;
  } else {
    return `${title + 'n'}`;
  }
};
